import { all } from 'redux-saga/effects';

import asr from './backendAsr';
import call from './backendCall';
import reloader from './backendReloader';
import user from './backendProfile';
import snooze from './backendSnooze';
import devices from './backendDevices';

export default function* rootSaga(): Generator<unknown, void, unknown> {
    yield all([...asr, ...call, ...reloader, ...user, ...snooze, ...devices]);
}
